import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios";
import { useOption } from "../../context/OptionContext";
import { set } from "date-fns";

const AjaxSelect = ({ id = "default-select", onChange, setAccountOptions }) => {
  const [options, setOptions] = useState([]);
  const { selectedOption, setSelectedOption } = useOption();
  const [loading, setLoading] = useState(true);
  // Fetch options only once on component mount
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get("/api/v1/marketplace_accounts/select_option");
        const data = response.data.map(item => ({
          id: String(item[0]),
          text: item[1],
        }));

        if (response?.data?.length === 0) {
          setAccountOptions && setAccountOptions(null)
        }

        const saved = JSON.parse(localStorage.getItem("marketplaceAcc"));
        let updatedOptions = [...data];

        // No saved selection yet
        if (!saved && data.length > 0) {
          const defaultOption = data[0];
          localStorage.setItem("marketplaceAcc", JSON.stringify(defaultOption));
          if (onChange) onChange(defaultOption);
        }
        // Saved item not in fetched options
        else if (saved) {
          const ids = new Set(data.map(opt => opt.id));
          if (!ids.has(saved.id)) {
            updatedOptions = [saved, ...data];
          }
        }

        setOptions(updatedOptions);
        if (!selectedOption && data.length > 0) {
          setSelectedOption(data[0]);
        }
      } catch (err) {
        console.error("Error fetching options:", err);
      }
      finally {
        setLoading(false)
      }
    };

    fetchOptions();
  }, []); // No onChange here to avoid infinite loops

  // Initialize and update select2
  useEffect(() => {
    if (options.length === 0) return;

    const $select = $(`#${id}`);
    const saved = JSON.parse(localStorage.getItem("marketplaceAcc"));
    let selected = options[0];

    if (saved) {
      const found = options.find(opt => opt.id === saved.id);
      selected = found || saved;
    }

    // Initialize select2
    $select.select2({
      data: options.map(opt => ({ id: opt.id, text: opt.text })),
    });

    if (selectedOption) {
      $select.val(selectedOption.id).trigger("change.select2");
    }

    // $select.val(selected.id).trigger("change.select2");

    const handleChange = () => {
      const selectedData = $select.select2("data")[0];
      if (!selectedData) return;
      setSelectedOption({ id: selectedData.id, text: selectedData.text });
    };

    $select.on("change", handleChange);

    // Cleanup on unmount
    return () => {
      $select.off("change", handleChange);
      if ($select.data("select2")) $select.select2("destroy");
    };
  }, [options, id, selectedOption, setSelectedOption]); // Removed onChange to avoid API loop

  return (
    <>
      {loading ? (
        <div
          className="skeleton skeleton-text mb-2"
          style={{
            width: "297px",
            height: "32px",
          }}
        />
      ) : (
        <select id={id} style={{ width: "297px" }}></select>
      )}
    </>
  );
};

export default AjaxSelect;


// import Select from "react-select";
// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const AjaxSelect = ({ onChange }) => {
//   const [options, setOptions] = useState([]);
//   const [selected, setSelected] = useState(null);

//   useEffect(() => {
//     axios.get("/api/v1/marketplace_accounts/select_option")
//       .then(res => {
//         const data = res.data.map(item => ({
//           value: String(item[0]),
//           label: item[1],
//         }));
//         setOptions(data);

//         // Check saved value in localStorage
//         const saved = JSON.parse(localStorage.getItem("marketplaceAcc"));
//         if (saved) {
//           const found = data.find(opt => opt.value === saved.id);
//           if (found) {
//             setSelected(found);
//           } else {
//             // fallback to saved, but convert into react-select format
//             setSelected({ value: saved.id, label: saved.text });
//           }
//         } else if (data.length > 0) {
//           // default to first option
//           setSelected(data[0]);
//           const objToSave = { id: data[0].value, text: data[0].label };
//           localStorage.setItem("marketplaceAcc", JSON.stringify(objToSave));
//           if (onChange) onChange(objToSave);
//         }
//       });
//   }, []);

//   const handleChange = (selectedOption) => {
//     setSelected(selectedOption);
//     const objToSave = { id: selectedOption.value, text: selectedOption.label };
//     localStorage.setItem("marketplaceAcc", JSON.stringify(objToSave));
//     if (onChange) onChange(objToSave);
//   };

//   return (
//     <Select
//       options={options}
//       value={selected}
//       onChange={handleChange}
//     />
//   );
// };

// export default AjaxSelect;
